import axioPath from '../../../api/axioPath';
import { UPDATE_DATA } from 'redux/actions/action_types'
import { showAppLoader, hideAppLoader } from '../app';
// import _ from 'lodash';

export const fetchReferralApi = (token) => (dispatch) => {
    dispatch(showAppLoader());
    return axioPath
        .get('/user/referralcode/getMyReferralCode', {
            headers: {
                Authorization: `${token}`,
            },
        })
        .then((response) => {
            setTimeout(() => {
                dispatch(hideAppLoader());
            }, 1000);
            dispatch({ type: UPDATE_DATA, payload: response.data });
            return response.data;
        })
        .catch((ex) => {
            dispatch(hideAppLoader());
            return ex;
        });
};

export const sendInviteViaEmailApi = (email, token) => (dispatch) => {
    dispatch(showAppLoader());
    return axioPath
        .get(`/user/referralcode/inviteByMail?emailId=${email}`, {
            headers: {
                Authorization: `${token}`,
            },
        })
        .then((response) => {
            setTimeout(() => {
                dispatch(hideAppLoader());
            }, 1000);
            dispatch({ type: UPDATE_DATA, payload: response.data });
            return response.data;
        })
        .catch((ex) => {
            dispatch(hideAppLoader());
            return ex;
        });
};

export const sendInviteViaLinkApi = (email, token) => (dispatch) => {
    dispatch(showAppLoader());
    return axioPath
        .get(`/user/referralcode/inviteByMailLink?emailId=${email}`, {
            headers: {
                Authorization: `${token}`,
            },
        })
        .then((response) => {
            setTimeout(() => {
                dispatch(hideAppLoader());
            }, 1000);
            dispatch({ type: UPDATE_DATA, payload: response.data });
            return response.data;
        })
        .catch((ex) => {
            dispatch(hideAppLoader());
            return ex;
        });
};